import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import { MERGING_GENERATING_SEC, VOICEOVER_GENERATING_SEC, VOICEOVER_TO_MERGING_SEC } from './mlAverageTasksDurations';

export const VIDEO_GENERATING_SEC_FOR_60_SEC_VIDEO =
  VOICEOVER_GENERATING_SEC + VOICEOVER_TO_MERGING_SEC + MERGING_GENERATING_SEC;
// Рассчитанные начальные проценты для каждого статуса генерации видео
// 1 для первого статуса
// x / (x + y + z + ...) для второго статуса
// (x + y) / (x + y + z + ...) для третьего статуса и тд. Меняем только делимое
const INITIAL_PERCENT = 1;
const VOICEOVER_TO_MERGING_INITIAL_PERCENT = getPercent(
  VOICEOVER_GENERATING_SEC,
  VIDEO_GENERATING_SEC_FOR_60_SEC_VIDEO,
);
const MERGING_INITIAL_PERCENT = getPercent(
  VOICEOVER_GENERATING_SEC + VOICEOVER_TO_MERGING_SEC,
  VIDEO_GENERATING_SEC_FOR_60_SEC_VIDEO,
);
const FINAL_PERCENT = 99;
// Константы для генерации видео
export const VIDEO_GENERATING_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.mergingStarted]: MERGING_GENERATING_SEC,
  [Status.voiceoverDone]: VOICEOVER_TO_MERGING_SEC,
  [Status.voiceoverStarted]: VOICEOVER_GENERATING_SEC,
};
export const INITIAL_PERCENT_FOR_GENERATING_VIDEO_STATUS: {
  [key in Status]?: number;
} = {
  [Status.mergingStarted]: MERGING_INITIAL_PERCENT, // 77
  [Status.voiceoverDone]: VOICEOVER_TO_MERGING_INITIAL_PERCENT,
  [Status.voiceoverStarted]: INITIAL_PERCENT,
};
export const FINAL_PERCENT_FOR_GENERATING_VIDEO_STATUS: {
  [key in Status]?: number;
} = {
  [Status.mergingStarted]: FINAL_PERCENT, // 99
  [Status.voiceoverDone]: MERGING_INITIAL_PERCENT,
  [Status.voiceoverStarted]: VOICEOVER_TO_MERGING_INITIAL_PERCENT,
};
